<template lang="pug">
  .layout
    y-dialog(v-if="showModal" v-model="showModal" scrollable persistent max-width='600px')
      v-card
        v-card-title(style="height:56px;")
          v-layout
            h6.basic800--text {{ $t('categories') }}
            v-spacer
            v-btn.my-auto.ml-2(small color="textColorAccent" outlined height="24" :style="{'background-color': $vuetify.theme.themes[$theme].infoT08}" @click="showAddProductDialog =! showAddProductDialog")
              eva-icon.ml-n2.mt-1(name="plus-outline" height="14" width="14" :fill="$vuetify.theme.themes[$theme].textColorAccent")
              .button-AA-tiny.textColorAccent--text {{ $t('add_category') }}
        v-divider.basic300
        v-card-text.px-0.pb-0
          v-layout.my-6(v-if="isFetching")
            v-row.fill-height.ma-0(align="center" justify="center")
              v-progress-circular.ma-auto(width="2" size="50" color="primary" indeterminate)
          .contain-layout(v-else)
            v-layout.my-6(v-if="categories.length == 0")
              v-row.fill-height.ma-0(align="center" justify="center")
                div.mx-auto
                  v-img.mx-auto(:src="require('@/assets/images/icon_empty.png')" style="width:80px; height:80px" contain)
                  p.caption {{ $t('no_categories_yet') }}
            .items-layout.pt-4(v-else)
              div.text-center.pb-2
                div.c1.mb-2.primary400--text {{ $t('drag_and_drop_the') }}
                  ArrowsSortIcon.mx-1.mb-n1(size="16" :style="{ 'color': $vuetify.theme.themes[$theme].basic700 }")
                  | {{ $t('icon_to_rearrange') }}
              draggable.my-2(tag="div" handle=".handle" :list="categories" @start="drag=true" @end="endMove" :move="checkMove")
                template(v-for='category in categories')
                  product-category-item(:category="category" :company="company" :key="category.id" @deleted="handleDeleteItem" :drag.sync="drag")
        v-card-actions
          v-spacer
          v-btn.mr-2(height="32" width="64" color="basic100" text @click='showModal = false')
            .button-Aa-small.textColorAccent--text {{$t('close')}}
    .modals
      add-product-categories(v-if="showAddProductDialog" :open.sync="showAddProductDialog" :company="company" @added="handleAddItem")
</template>

<script>
import ProductCategoryItem from '@/components/ProductCategoryItem.vue'
import AddProductCategories from '@/components/dialogs/AddProductCategories.vue'
import draggable from 'vuedraggable'

export default {
  name: 'ManageProductCategoryDialog',
  props: ['open', 'company'],
  components: { ProductCategoryItem, AddProductCategories, draggable },
  data: () => ({
    isFetching: false,
    categories: [],
    showAddProductDialog: false,
    drag: false,
    fromCategoryId: null,
    params: {}
  }),
  mounted () {
    this.fetchCategories()
  },
  computed: {
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    }
  },
  methods: {
    fetchCategories () {
      this.isFetching = true
      let url = `/product_categories/?page_size=-1&company=${this.company.id}`
      this.$axios.get(url).then((response) => {
        if (response.data.results) {
          this.categories = response.data.results
        }
      })
      .catch(() => {})
      .finally(() => {
        this.isFetching = false
      })
    },
    handleDeleteItem (item) {
      this.categories = this.categories.filter((x) => x !== item)
    },
    handleAddItem (item) {
      this.categories.push(item)
    },
    checkMove (e) {
      let fromCategory = this.categories[e.draggedContext.index]
      let toCategory = this.categories[e.draggedContext.futureIndex]
      this.params = {
        category: toCategory.id,
        direction: e.draggedContext.futureIndex > e.draggedContext.index ? 'down' : 'up'
      }
      this.fromCategoryId = fromCategory.id
    },
    endMove () {
      this.drag = false
      if (!this.fromCategoryId) {
        return
      }
      if (this.fromCategoryId === this.params.category) {
        return
      }
      this.$axios.post(`/product_categories/${this.fromCategoryId}/move/`, this.params).catch(() => {})
    }
  }
}
</script>

<style scoped>
</style>

<i18n>
{
  "en": {
    "drag_and_drop_the": "Drag and drop the",
    "icon_to_rearrange": "icon to rearrange the categories"
  },
  "id": {
    "drag_and_drop_the": "tarik dan letakkan",
    "icon_to_rearrange": "ikon untuk mengurutkan kategori"
  }
}
</i18n>
